import { render } from "./ButtonSelect.vue?vue&type=template&id=45a80516&scoped=true"
import script from "./ButtonSelect.vue?vue&type=script&lang=js"
export * from "./ButtonSelect.vue?vue&type=script&lang=js"

import "./ButtonSelect.vue?vue&type=style&index=0&id=45a80516&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a80516"]])

export default __exports__